<template>
  <el-dialog class="login-popup" :visible="showDialog" @close="onClose()" width="630px" lock-scroll
  >
    <div class="title" slot="title"></div>
    <div class="content">
          <div class="left-bar">

    </div>
    <div class="right-content">
      <div class="input-area" v-if="!showRegisterSuccess">
        <div class="title">
          {{showRegister?'創建帳號':"會員登入"}}
          <div class="switch">
            {{showRegister?'已經是會員了？':"還不是會員"}}
            <div class="btn" @click="showRegister = !showRegister">{{showRegister?'會員登入':"註冊會員"}}</div>
          </div>
        </div>
        <div>  
          <div class="social">
            <el-button id="FB_login" class="btn btn-large btn-primary" 
           >FB 登入</el-button> <el-button id="FB_logout" class="btn btn-large btn-warning">Google 登入</el-button>
          </div> 
          <div class="or">或</div>
          <p class="err" v-if="showErr">帳號或密碼錯誤，請確認</p>
          <el-form v-if="!showRegister" :model="loginForm" :rules="loginRules" ref="loginForm">
              <el-form-item  prop="email">
                  <el-input placeholder="請輸入信箱" v-model="loginForm.email"></el-input>
              </el-form-item>
              <el-form-item  prop="password">
                  <el-input placeholder="請輸入密碼" type="password" v-model="loginForm.password"></el-input>
              </el-form-item>
              <el-form-item> 
                <div class="btn-group">
                  <el-button type="primary" @click="doLogin">登入</el-button>
                  <el-button @click="onClose">取消</el-button>
                </div>
            </el-form-item>
          </el-form>
          <registerPopup v-if="showRegister" @registerSuccess="registerSuccess"></registerPopup>
      </div>
    
      </div>
      <div class="success" v-else>
        <p class="success-title"> 註冊成功</p>
        <p class="desc">請至註冊信箱收認證信完成註冊流程</p>
    </div>
    </div>
    </div>
    
  </el-dialog>
</template>

<script>
import { mapState,mapActions } from 'vuex'
import  registerPopup from './registerPopup'
export default {
    props: {
        showDialog: {
            type: Boolean,
            require: true
        },
    },
    components:{
      registerPopup
    },
    data(){
      var validateEmail = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('請輸入email'));
        } else if (value.search(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/)== -1) {
          callback(new Error('email格式不正確'));
        } else {
          callback();
        }
      };
      var validatePassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value.length<6 || value.length>10) {
          callback(new Error('請輸入6-10位的密碼'));
        } else {
          callback();
        }
      };
      return{
        loginSuccess: false,
        loginForm:{
          email:"",
          password:"",
        },
        loginRules: {
          email: [
            { validator: validateEmail, trigger: 'blur' }
          ],
          password: [
            { validator: validatePassword, trigger: 'blur' }
          ],
        },
        showErr: false,
        showRegister: false,
        showRegisterSuccess: false,
      }
    },
    mounted(){
        
    },
    computed:{
      ...mapState({
            userImg: state => state.user.userImg,
            userName: state => state.user.userName,
        }),
        isLogin(){
            return this.$store.state.user.userName?true:false
        }
    },
    methods:{
        ...mapActions('user', ['fbLogin','userLogin']),
      async doLogin(){
        await this.userLogin(this.loginForm)
        this.onClose()
        window.location.reload()
      },
      registerSuccess(val){
        this.showRegisterSuccess = true
        this.loginForm = val
      },
      onClose(){
        if (this.showRegisterSuccess){
          this.doLogin()
        }
        this.$hideLoginPopup()
      }
    }
    
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 0;
}
/deep/ .el-dialog__header {
  padding: 0;
}
.login-popup {
  .content{
    display: flex;
    .left-bar {
      width: 200px;
      background-color: aquamarine;
    }
    .right-content{
      width: 430px;
      padding: 50px 80px 0;
      box-sizing: border-box;
      .title {
        display: flex;
        align-items: center;
        justify-content:flex-start;
        font-size: 30px;
        font-weight: 600;
        margin: 0 auto 15px;
        .switch {
          font-size: 12px;
          color: $textColor;
          margin-left: 30px;
          line-height: 20px;
          .btn {
            color: $mainColor;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
      .social {
        display: flex;
        justify-content: space-between;
        button {
          width: 150px;
        }
      }
      .or {
        text-align: center;
        color: $textColor;
        margin: 15px 0;
        font-size: 12px;
      }
      .authorize {
        font-size: 12px;
        color: $textColor;
        span {
          color: $mainColor;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      .btn-group {
        display: flex;
        flex-direction: column;
        button {
          margin: 10px 0;
        }
      }
      .success {
        padding-bottom: 50px;
        .success-title{
          font-size: 30px;
          font-weight: 600;
        }
        .desc {
          margin-top: 20px;
        }
      }
    }
  }
}

</style>